// extracted by mini-css-extract-plugin
module.exports = {"main":"Layout_main__3EFPA","layout":"Layout_layout__bx-4T"};